const rankingItems = [
  { rank: 1, title: '星际迷航：新纪元', type: '科幻 / 冒险', hot: '9.8', trend: 'up' },
  { rank: 2, title: '迷雾追踪', type: '悬疑 / 犯罪', hot: '9.6', trend: 'up' },
  { rank: 3, title: '速度与激情12', type: '动作 / 冒险', hot: '9.5', trend: 'up' },
  { rank: 4, title: '深海危机', type: '灾难 / 剧情', hot: '9.3', trend: 'new' },
  { rank: 5, title: '笑傲江湖之东方不败', type: '武侠 / 古装', hot: '9.1', trend: 'up' },
  { rank: 6, title: '暗夜追踪者', type: '动作 / 惊悚', hot: '8.9', trend: 'down' },
  { rank: 7, title: '夏日奇遇记', type: '喜剧 / 家庭', hot: '8.7', trend: 'new' },
];

export default function Ranking() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="section-container">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-900 mb-3">
            热播排行
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-2xl mx-auto">
            全网热门电影实时排行榜，看看大家都在看什么
          </p>
        </div>
        <div className="max-w-2xl mx-auto">
          {rankingItems.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-4 py-4 px-4 border-b border-background-200/60 last:border-b-0 group hover:bg-background-50/70 rounded-lg transition-colors cursor-pointer"
            >
              <span className={`w-8 h-8 flex items-center justify-center rounded-lg font-bold text-sm whitespace-nowrap ${
                item.rank <= 3
                  ? 'bg-primary-500 text-white'
                  : 'bg-background-200 text-foreground-500'
              }`}>
                {item.rank}
              </span>
              <div className="flex-1 min-w-0">
                <h3 className="font-heading font-semibold text-foreground-900 text-sm md:text-base truncate group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-400 mt-0.5">{item.type}</p>
              </div>
              <div className="flex items-center gap-1.5">
                {item.trend === 'up' && <i className="ri-arrow-up-fill text-primary-500 text-xs"></i>}
                {item.trend === 'new' && <i className="ri-sparkling-fill text-accent-500 text-xs"></i>}
                {item.trend === 'down' && <i className="ri-arrow-down-fill text-foreground-300 text-xs"></i>}
                <span className="text-sm font-semibold text-primary-500 whitespace-nowrap">{item.hot}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}